/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * Street name and number. Required
     * @type {string}
     * @memberof AddressDto
     */
    address1?: string;
    /**
     *
     * @type {string}
     * @memberof AddressDto
     */
    address2?: string;
    /**
     *
     * @type {string}
     * @memberof AddressDto
     */
    city?: string;
    /**
     *
     * @type {string}
     * @memberof AddressDto
     */
    stateCode?: string;
    /**
     *
     * @type {string}
     * @memberof AddressDto
     */
    postCode?: string;
    /**
     * 2 letter ISO country code. Required
     * @type {string}
     * @memberof AddressDto
     */
    countryCode?: string;
    /**
     *
     * @type {number}
     * @memberof AddressDto
     */
    latitude?: number;
    /**
     *
     * @type {number}
     * @memberof AddressDto
     */
    longitude?: number;
    /**
     *
     * @type {string}
     * @memberof AddressDto
     */
    timeZone?: string;
    /**
     * Optional Google Place Id, can be used to link to a specific listing in Maps rather than just lat/lng. Eg https://www.google.com/maps/place/?q=place_id:{placeId}
     * @type {string}
     * @memberof AddressDto
     */
    googlePlaceId?: string;
    /**
     *
     * @type {Date}
     * @memberof AddressDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof AddressDto
     */
    updatedAt?: Date;
}

/**
 * Check if a given object implements the AddressDto interface.
 */
export function instanceOfAddressDto(value: object): value is AddressDto {
    return true;
}

export function AddressDtoFromJSON(json: any): AddressDto {
    return AddressDtoFromJSONTyped(json, false);
}

export function AddressDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): AddressDto {
    if (json == null) {
        return json;
    }
    return {
        address1: json["address1"] == null ? undefined : json["address1"],
        address2: json["address2"] == null ? undefined : json["address2"],
        city: json["city"] == null ? undefined : json["city"],
        stateCode: json["stateCode"] == null ? undefined : json["stateCode"],
        postCode: json["postCode"] == null ? undefined : json["postCode"],
        countryCode:
            json["countryCode"] == null ? undefined : json["countryCode"],
        latitude: json["latitude"] == null ? undefined : json["latitude"],
        longitude: json["longitude"] == null ? undefined : json["longitude"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        googlePlaceId:
            json["googlePlaceId"] == null ? undefined : json["googlePlaceId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
    };
}

export function AddressDtoToJSON(value?: AddressDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        address1: value["address1"],
        address2: value["address2"],
        city: value["city"],
        stateCode: value["stateCode"],
        postCode: value["postCode"],
        countryCode: value["countryCode"],
        latitude: value["latitude"],
        longitude: value["longitude"],
        timeZone: value["timeZone"],
        googlePlaceId: value["googlePlaceId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
    };
}
